export const ARRIVAL_TIME = 'arrival_time'
export const DEPARTURE_TIME = 'departure_time'
export const REALTIME_ARRIVAL = 'realtime_arrival'
export const SCHEDULE_ARRIVAL_ETA = 'arrival_eta'
export const REGX_EMAIL_HEAD = /^[a-zA-Z0-9]+[a-zA-Z0-9.\-_+]+$/
